<template>
    <vPartnerCurrentWithholdComponent :postList="postList" v-if="flag"></vPartnerCurrentWithholdComponent>
</template>
<script>
import vPartnerCurrentWithholdComponent from '../../listComponent/basicdata/partnerCurrentWithhold/partnerCurrentWithholdComponent.vue';
export default {
    name: 'account',
    components: {
        vPartnerCurrentWithholdComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                updateBtn: false,
                uploadBtn: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                rid: true,
                partner_current_rid: true,
                remark: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>